<template>
	<div>
		<div class="vx-row mb-2">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="Korting voor via webshop kopen (%)" v-model="discountRules.shop" />
			</div>
		</div>
		<div class="vx-row mb-2">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="Korting voor direct betalen (%)" v-model="discountRules.payment" />
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<vs-button class="mr-3 mb-2" @click="saveDiscountRules()" color="success">Opslaan</vs-button>
			</div>
		</div>
	</div>
</template>
<script>
	import api from '../api';
	export default {
		name: 'DiscountRules',
		components: {},
		props: {},
		data () {
			return {
				discountRules: {}
			}
		},
		computed: {

		},
		mounted () {
			this.getDiscountRules();
		},
		methods: {
			getDiscountRules(){
				api.post("admin/settings", {keys: ['discountRules']}).then(response=>{
					console.log(response);
					this.discountRules = response.data[0].value;
				}).catch((error)=>{
					console.log(error);
				})
			},
			saveDiscountRules(){
				api.put("admin/settings", {settings: {'discountRules': this.discountRules}}).then(()=>{
					this.$vs.dialog({
						title: 'Gelukt!',
						text: 'Opslaan van de discount regels is gelukt',
						color: 'success'
					})
				}).catch((error)=>{
					console.log(error);
				})
			},
		}
	}

</script>
